export default "__VITE_ASSET__BuBP2658__"